/* global MutationObserver */
jQuery(document).ready(function ($) {
    function initContainer(container) {
        const postsEl = container.find('[class*="post-result_"]');
        const loadMoreWrapper = container.find('.load-more-wrapper');
        if (!postsEl.length || !loadMoreWrapper.length) return;

        const totalPosts = parseInt(postsEl.data('total-posts'), 10);

        // Hide load more if totalPosts is missing or invalid
        if (!Number.isFinite(totalPosts) || totalPosts <= 0) {
            loadMoreWrapper.hide();
            return;
        }

        const checkVisibility = () => {
            loadMoreWrapper.toggle(postsEl.children('.post-card').length < totalPosts);
        };

        checkVisibility();

        // Disconnect previous posts observer before creating a new one
        const prevPostsObserver = container.data('loadMorePostsObserver');
        if (prevPostsObserver) prevPostsObserver.disconnect();

        const postsObserver = new MutationObserver(checkVisibility);
        postsObserver.observe(postsEl[0], { childList: true });
        container.data('loadMorePostsObserver', postsObserver);
    }

    $('.post-result-container').each(function () {
        const container = $(this);
        initContainer(container);

        // Disconnect previous container observer before creating a new one
        const prevContainerObserver = container.data('loadMoreContainerObserver');
        if (prevContainerObserver) prevContainerObserver.disconnect();

        // Re-init when S&F replaces inner HTML after a keyword search/filter change
        const containerObserver = new MutationObserver(() => initContainer(container));
        containerObserver.observe(this, { childList: true });
        container.data('loadMoreContainerObserver', containerObserver);
    });
});